<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-0 content-block-head">
      <div class="col p-2">
        <h4>All Documents</h4>
      </div>
    </div>
    <app-image-view-modal [image]='this.image'></app-image-view-modal>
    <!-- <div class="row">
      <div class="col">
        <button class='btn btn-block btn-success' (click)='openModal("documentUploadModal")'>Upload Document</button>
      </div>
      <app-document-upload-modal [vehicleId]='this.vehicleId'></app-document-upload-modal>
    </div> -->

    <div class="row mt-3">
      <div class="col">
        <app-grid
          entity='documents'
          [filters]='this.filters'
          [columns]='this.columns'
          [buttons]='this.buttons'
          [searchFilters]='this.searchFilters'
          [searchFields]='this.searchFields'
          >
        </app-grid>
      </div>
    </div>
  </div>
</div>
